import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { createNavigatorFactory, StackActions, StackRouter, useNavigationBuilder } from "@react-navigation/native";
import * as React from "react";
import warnOnce from "warn-once";
import StackView from "../views/Stack/StackView";
function StackNavigator(_param) {
    var id = _param.id, initialRouteName = _param.initialRouteName, children = _param.children, screenListeners = _param.screenListeners, screenOptions = _param.screenOptions, rest = _object_without_properties(_param, [
        "id",
        "initialRouteName",
        "children",
        "screenListeners",
        "screenOptions"
    ]);
    // @ts-expect-error: mode is deprecated
    var mode = rest.mode;
    warnOnce(mode != null, "Stack Navigator: 'mode=\"".concat(mode, "\"' is deprecated. Use 'presentation: \"").concat(mode, "\"' in 'screenOptions' instead.\n\nSee https://reactnavigation.org/docs/stack-navigator#presentation for more details."));
    // @ts-expect-error: headerMode='none' is deprecated
    var headerMode = rest.headerMode;
    warnOnce(headerMode === "none", "Stack Navigator: 'headerMode=\"none\"' is deprecated. Use 'headerShown: false' in 'screenOptions' instead.\n\nSee https://reactnavigation.org/docs/stack-navigator/#headershown for more details.");
    warnOnce(headerMode != null && headerMode !== "none", "Stack Navigator: 'headerMode' is moved to 'options'. Moved it to 'screenOptions' to keep current behavior.\n\nSee https://reactnavigation.org/docs/stack-navigator/#headermode for more details.");
    // @ts-expect-error: headerMode='none' is deprecated
    var keyboardHandlingEnabled = rest.keyboardHandlingEnabled;
    warnOnce(keyboardHandlingEnabled !== undefined, "Stack Navigator: 'keyboardHandlingEnabled' is moved to 'options'. Moved it to 'screenOptions' to keep current behavior.\n\nSee https://reactnavigation.org/docs/stack-navigator/#keyboardhandlingenabled for more details.");
    var defaultScreenOptions = {
        presentation: mode,
        headerShown: headerMode ? headerMode !== "none" : true,
        headerMode: headerMode && headerMode !== "none" ? headerMode : undefined,
        keyboardHandlingEnabled: keyboardHandlingEnabled
    };
    var _useNavigationBuilder = useNavigationBuilder(StackRouter, {
        id: id,
        initialRouteName: initialRouteName,
        children: children,
        screenListeners: screenListeners,
        screenOptions: screenOptions,
        defaultScreenOptions: defaultScreenOptions
    }), state = _useNavigationBuilder.state, descriptors = _useNavigationBuilder.descriptors, navigation = _useNavigationBuilder.navigation, NavigationContent = _useNavigationBuilder.NavigationContent;
    React.useEffect(function() {
        var // @ts-expect-error: there may not be a tab navigator in parent
        _navigation_addListener;
        return (_navigation_addListener = navigation.addListener) === null || _navigation_addListener === void 0 ? void 0 : _navigation_addListener.call(navigation, "tabPress", function(e) {
            var isFocused = navigation.isFocused();
            // Run the operation in the next frame so we're sure all listeners have been run
            // This is necessary to know if preventDefault() has been called
            requestAnimationFrame(function() {
                if (state.index > 0 && isFocused && !e.defaultPrevented) {
                    // When user taps on already focused tab and we're inside the tab,
                    // reset the stack to replicate native behaviour
                    navigation.dispatch(_object_spread_props(_object_spread({}, StackActions.popToTop()), {
                        target: state.key
                    }));
                }
            });
        });
    }, [
        navigation,
        state.index,
        state.key
    ]);
    return /*#__PURE__*/ _jsx(NavigationContent, {
        children: /*#__PURE__*/ _jsx(StackView, _object_spread_props(_object_spread({}, rest), {
            state: state,
            descriptors: descriptors,
            navigation: navigation
        }))
    });
}
export default createNavigatorFactory(StackNavigator);
